// Look into https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/import
(function ($, root, undefined) {

    $(function () {

        $('html').removeClass('no-js');

        mobile();
        nav();
        tabNav();
        lightboxes();
        share();
        loader();
        home();
        consult();
        swipers();

    });

})(jQuery, this);
